export const company={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'Industar kft',
    heroP:'Cégbemutató',
    imgStart:false,
    to:'timeline',
    image:"/images/industar-kft-front.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const termek={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/termekmix.png",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const lada={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/Termék_Lada.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const warthburg={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/Termék_Wartburg.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const dacia={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/Termék_Dacia.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const skoda={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/Termék_Skoda.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const trabant={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/Termék_Trabant.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
  export const contacts={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:false,
    heroH1:'Kapcsolatok',
    heroP:'',
    imgStart:false,
    to:'timeline',
    image:"/images/industar-kft-front.jpg",
    alt:'Car',
    dark:true,
    primary:true,
    darkText:true,
  
  };
 